import classnames from 'classnames'
import React, { useState } from 'react'

import RichText from '@src/quince-site-common/src/domains/RichText'

import { RichText as RichTextC, RichTextProps } from '../../molecules'

import styles from './accordianItem.module.scss'
import ChevronDown from './icons/chevronDown.inline.svg'

export interface AccordianItemProps {
  initialState?: boolean
  header: RichText | undefined
  body: RichText | undefined
  className?: string
  onClick?: () => void
  key?: string | number
  showNewPdpDesignV2?: boolean
}

const AccordianItem = ({ initialState, header, body, className, onClick, showNewPdpDesignV2 }: AccordianItemProps) => {
  const [show, setShow] = useState(initialState)

  const handleClick: React.MouseEventHandler<HTMLElement> = e => {
    e.preventDefault()
    setShow(prevState => !prevState)
    if (onClick) onClick()
  }

  const headerRichTextProps: RichTextProps | undefined = RichText.makeRichTextProps(header)
  const bodyRichTextProps: RichTextProps | undefined = RichText.makeRichTextProps(body)

  return (
    <details className={classnames(styles.wrapper, className)} open={show}>
      <summary
        className={classnames(styles.wrapper__header, {
          [styles.wrapper__header_newPdpDesignV2 ?? '']: showNewPdpDesignV2,
        })}
        onClick={handleClick}
      >
        <div className={styles.wrapper__header__text}>
          {header && headerRichTextProps && <RichTextC {...headerRichTextProps} />}
        </div>
        <div
          className={classnames(styles.wrapper__header__sign, {
            [styles.wrapper__header__sign_newPdpDesignV2 ?? '']: showNewPdpDesignV2,
          })}
        >
          <ChevronDown className={show ? styles.wrapper__header__sign__rotate : ''} />
        </div>
      </summary>
      <div className={styles.wrapper__body}>{body && bodyRichTextProps && <RichTextC {...bodyRichTextProps} />}</div>
    </details>
  )
}
export default AccordianItem
